/* eslint-disable no-param-reassign */
export const getLDRelayURL = (hostname: string, initialUser: string) => {
  let env = '';
  const smilesDomain = hostname.indexOf('smiles.com.br') > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const res = rx.exec(hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, '').replace('uat', 'hml');
  }

  if (hostname === 'localhost') {
    env = '-hml5';
    initialUser = 'https://voebiz-uat5.smiles.com.br';
  }

  return { url: `https://ldrelay${env}.smiles.com.br`, ldUser: initialUser };
};
